enum BreadcrumbItemType {
  Creations = 'creations',
  Games = 'games',
  GamePass = 'passes',
  Badge = 'badges',
  Bundle = 'bundle',
  DeveloperProduct = 'developer-products',
  ExternalPurchaseSettings = 'external-purchase-settings',
  Catalog = 'catalog',
  AssociatedItems = 'associated-items',
  Localization = 'localization',
  ActivityHistory = 'activity-history',
  Notifications = 'notifications',
  SocialLinks = 'social-links',
  Translation = 'translation',
  Overview = 'overview',
  ContributionReport = 'contribution-report',
  Alerts = 'alerts',
  AnalyticsMonetization = 'analytics-monetization',
  AnalyticsRetention = 'analytics-retention',
  AnalyticsEngagement = 'analytics-engagement',
  AnalyticsAcquisition = 'analytics-acquisition',
  AnalyticsPerformance = 'analytics-performance',
  AnalyticsCrashes = 'analytics-crashes',
  AnalyticsExploreMode = 'analytics-explore-mode',
  AnalyticsAudience = 'analytics-audience',
  AnalyticsEconomy = 'analytics-economy',
  AnalyticsFunnels = 'analytics-funnels',
  AnalyticsErrorReport = 'analytics-error-report',
  AnalyticsMemoryStores = 'analytics-memory-stores',
  AnalyticsDataStores = 'analytics-data-stores',
  AnalyticsHttpServicce = 'analytics-http-service',
  AnalyticsMessagingService = 'analytics-messaging-service',
  AnalyticsSpeechToText = 'analytics-speech-to-text',
  AnalyticsTextToSpeech = 'analytics-text-to-speech',
  AnalyticCustomEvents = 'analytics-custom-events',
  ImmersiveAds = 'immersive-ads',
  Questionnaire = 'experience-questionnaire',
  Guidelines = 'guidelines',
  Configure = 'configure',
  CommunicationSettings = 'communication-settings',
  Sales = 'sales',
  Promotions = 'promotions',
  Create = 'create',
  ConfigCreate = 'config-create',
  Updates = 'updates',
  Places = 'places',
  Manage = 'manage',
  Icon = 'icon',
  Event = 'event',
  SelectEligibility = 'selectEligibility',
  Thumbnails = 'thumbnails',
  Access = 'access',
  Secrets = 'secrets',
  CreatorStore = 'store',
  Settings = 'settings',
  Permissions = 'permissions',
  Webhooks = 'webhooks',
  Community = 'community',
  Category = 'category',
  Experiences = 'experiences',
  ExperienceSubscription = 'experience-subscriptions',
  Commerce = 'commerce',
  CreateProducts = 'create-products',
  Preferences = 'preferences',
  Advanced = 'advanced',
  DataSharing = 'data-collection',
  PricedAssets = 'priced-assets',
  Eligibility = 'eligibility',
  AudioDistribution = 'audio-distribution',
  PriceOptimization = 'price-optimization',
  PriceCheck = 'price-check',
  Bans = 'bans',
  Add = 'add',
  Reorder = 'reorder',
  AvatarCreationTokens = 'avatar-creation-tokens',
  CustomMatchmaking = 'custom-matchmaking',
  CreateMatchmakingConfiguration = 'create-configuration',
  CreateMatchmakingAttribute = 'create-attribute',
  EditMatchmakingConfiguration = 'edit-configuration',
  EditMatchmakingServerAttribute = 'edit-server-attribute',
  EditMatchmakingPlayerAttribute = 'edit-player-attribute',
  PaidAccess = 'paid-access',
  PublicPublish = 'public-publish',
  PublishingPermissions = 'publishing-permissions',
  Feedback = 'feedback',
  ApiSettings = 'api-settings',
  Configs = 'configs',
  ConfigsHistory = 'configs-history',
  Experiments = 'experiments',
  ExperimentCreate = 'experiment-create',
  ExperimentDetails = 'experiment-details',
  ReferralRewards = 'referral-reward-details',
  Environments = 'environments',
  Collaborators = 'collaborators',
  Look = 'look',
  RecommendationService = 'recommendation-service',
  ServerManagement = 'server-management-service',
  ManagedPricing = 'managed-pricing',
  HardCodedPrices = 'hard-coded-prices',
}

export default BreadcrumbItemType;
